export const kplerVesselTypes = [
  'Unspecified',
  'Fishing',
  'Pleasure Craft',
  'Cargo',
  'Sailing Vessel',
  'Tug',
  'General Cargo',
  'Reserved',
  'Other',
  'Passenger',
  'Fishing Vessel',
  'Tanker',
  'Bulk Carrier',
  'Trawler',
  'SAR',
  'Container Ship',
  'High Speed Craft',
  'Law Enforce',
  'Oil Products Tanker',
  'Port Tender',
  'Wing In Grnd',
  'Multi Purpose Offshore Vessel',
  'Dredger',
  'SAR Aircraft',
  'Oil/Chemical Tanker',
  'Manned VTS',
  'Reference Point',
  'Pilot Vessel',
  'Military Ops',
  'Crude Oil Tanker',
  'Special Mark - Sea Farm',
  'Navigation Aid',
  'Passenger Ship',
  'Ro-Ro/Passenger Ship',
  'Inland, Motor Freighter',
  'Starboard Hand Mark',
  'Port Hand Mark',
  'Inland, Unknown',
  'Local Vessel',
  'Yacht',
  'Isolated Danger',
  'Anti-Pollution',
  'Reefer',
  'RACON',
  'LPG Tanker',
  'Dive Vessel',
  'Chemical Tanker',
  'Inland, Pleasure Craft, >20 metres',
  'Cargo - Hazard A (Major)',
  'Spare',
  'Research/Survey Vessel',
  'Light, without Sectors',
  'Fish Carrier',
  'Patrol Vessel',
  'Vehicles Carrier',
  'Landing Craft',
  'Inland, Passenger Ship, Ferry, Cruise ship',
  'Ro-Ro Cargo',
  'Inland, Passenger Ship without Accommodation',
  'Aggregates Carrier',
  'Crew Boat',
  'Beacon, Port Hand',
  'OffShore Structure',
  'Safe Water',
  'Offshore Supply Ship',
  'Beacon, Starboard Hand',
  'Tanker - Hazard A (Major)',
  'Hopper Dredger',
  'LNG Tanker',
  'Passenger/Cargo Ship',
  'Deck Cargo Ship',
  'Inland, Motor Tanker, liquid cargo, type C',
  'Inland, Maintainance Craft, Cableship, Dredger',
  'Beacon, Special Mark',
  'Ore Carrier',
  'Cargo - Hazard B',
  'Work Vessel',
  'Bunkering Tanker',
  'Barge Carrier',
  'Fire Fighting Vessel',
  'Cement Carrier',
  'Utility Vessel',
  'Special Craft',
  'Pusher Tug',
  'Anchor Handling Vessel',
  'Floating Storage/Production',
  'Motor Hopper',
  'Inland, Motor Tanker',
  'Cargo - Hazard C (Minor)',
  'Inland, Tug, single',
  'Inland, Service Vessel, Police Patrol',
  'Inland Cargo',
  'Tank Barge',
  'LPG/Chemical Tanker',
  'Drilling Jack Up',
  'Light, with Sectors',
  'Leading Light Front',
  'Inland, Pushboat, Single',
  'Pilot Ship',
  'Light Vessel - LANBY - Rig',
  'Fishery Patrol Vessel',
  'Inland Tanker',
  'Deck Cargo Pontoon',
  'Cardinal Mark W',
  'Cardinal Mark N',
  'Pollution Control Vessel',
  'Tanker - Hazard B',
  'Factory Trawler',
  'Obo Carrier',
  'Standby Safety Vessel',
  'Inland Passenger Ship',
  'Crane Ship',
  'Heavy Lift Vessel',
  'Cargo - Hazard D (Recognizable)',
  'Tug/Supply Vessel',
  'Suction Dredger',
  'Towing Vessel',
  'Salvage/Rescue Vessel',
  'Inland, Pushtow, one cargo barge',
  'Asphalt/Bitumen Tanker',
  'Tanker - Hazard C (Minor)',
  'Livestock Carrier',
  'Inland, Ferry',
  'Cardinal Mark E',
  'Medical Trans',
  'Work Pontoon',
  'Beacon, Isolated danger',
  'Cardinal Mark S',
  'Preferred Channel Port Hand',
  'Leading Light Rear',
  'Inland Supply Vessel',
  'Drill Ship',
  'Tanker - Hazard D (Recognizable)',
  'Wood Chips Carrier',
  'Training Ship',
  'Preferred Channel Starboard Hand',
  'Fish Factory',
  'Floating Crane',
  'Grab Dredger',
  'Water Tanker',
  'Heavy Load Carrier',
  'Beacon, Cardinal W',
  'Trailing Suction Hopper Dredger',
  'Beacon, Cardinal E',
  'Inland, Motor Tanker, liquid cargo, type N',
  'Inland, Cruise Ship',
  'Beacon, Cardinal S',
  'Buoy-Laying Vessel',
  'Beacon, Safe Water',
  'Floating Linkspan',
  'Self Discharging Bulk Carrier',
  'Beacon, Cardinal N',
  'Cable Layer',
  'Waste Disposal Vessel',
  'Inland, Pushtow, two cargo barges',
  'Inland, Motor Freighter Pushing Freighter(s)',
  'Beacon, Preferred Channel Starboard hand',
  'Hopper Barge',
  'Diving Support Vessel',
  'Ro-Ro/Container Carrier',
  'Whaler',
  'Inland Ro-Ro Cargo Ship',
  'Accommodation Ship',
  'Inland, Bunkership',
  'Icebreaker',
  'Beacon, Preferred Channel Port hand',
  'Pipe Layer',
  'Hydrofoil',
  'Combat Vessel',
  'Naval Auxiliary Vessel',
  'Inland, Fishing Boat',
  'Replenishment Vessel',
  'Tender',
  'Bucket Ladder Dredger',
  'Fishery Research Vessel',
  'Supply Tender',
  'Mooring Vessel',
  'Inland, Container Vessel',
  'Museum Ship',
  'Inland, Tug, Freighter',
  'Edible Oil Tanker',
  'Cutter Suction Dredger',
  'Offshore Construction Jack Up',
  'Inland, Tug, one or more tows',
  'Cargo Barge',
  'Inland, General Cargo maritime',
  'Inland, Motor Freighter with Ships Alongside',
  'Hovercraft',
  'Inland, Motor Freighter, Tug',
  'Inland, Gas Tanker',
  'Inland, Pushtow, six cargo barges',
  'Logistics Naval Vessel',
  'Inland, Pushtow, four cargo barges',
  'Floating Hotel/Restaurant',
  'Supply Vessel',
  'Inland, Freightbarge',
  'Inland, Object, not otherwise specified',
  'Pipelay Crane Vessel',
  'Inland, Tanker',
  'Inland, Motor Tanker, dry cargo as if liquid',
  'Limestone Carrier',
  'Inland, Tug, assisting a vessel or combination',
  'Inland Dredger',
  'Articulated Pusher Tug',
  'Well Stimulation Vessel',
  'Houseboat',
  'Hospital Ship',
  'Timber Carrier',
  'Bulk Carrier With Vehicle Deck',
  'Exhibition Ship',
  'Wine Tanker',
  'Pallet Carrier',
  'Crane Barge',
  'Cement Barge',
  'Support Jack Up',
  'Drill Barge',
  'Dredging Pontoon',
  'Fishery Support Vessel',
  'Inland, Pushtow, three cargo barges',
  'Inland, Pushtow, one tank/gas barge',
  'Offshore Construction Vessel',
  'Maintenance Platform',
  'Nuclear Fuel Carrier',
  'Inland, Pushtow, five cargo barges',
  'Inland, Tug Freighter, coupled',
  'Fruit Juice Tanker',
  'Pile Driving Vessel',
  'Accommodation Platform',
  'Tank-Cleaning Vessel',
  'Inland, Tankbarge, liquid cargo, type C',
  'Sealer',
  'Bulk Storage Barge',
  'Inland, Object, Towed, not otherwise specified',
  'Inland Tug',
  'Power Station Vessel',
  'Inland, Pushtow, nine or more barges',
  'Wing In Ground Effect Vessel',
  'Mining Vessel',
  'Power Station Pontoon',
  'Troopship',
  'Floating Sheerleg',
  'Rail/Vehicles Carrier',
  'Accommodation Jack Up',
  'Inland, Tankbarge',
  'Cabu Carrier',
  'Stone Carrier',
  'Tug/Ice Breaker',
  'Inland, Pushtow, eigth cargo barges',
  'Inland, Pushtow, eight cargo barges',
  'Mission Ship',
  'Radio Ship',
  'Jacket Launching Pontoon',
  'Inland, Tug, Tanker',
  'Sludge Carrier',
  'Aggregates Barge',
  'CO2 Tanker',
  'Pipe Carrier',
  'Production Testing Vessel',
  'Drilling Rig',
  'Inland, Bulk Carrier maritime',
  'Inland, Tankbarge, liquid cargo, type N',
  'Inland, Pushtow, two barges at least one tanker',
  'Inland, Pushtow, nine+ barges at least one tanker',
  'Powder Carrier',
  'Special Vessel',
  'Inland, Fast Ship',
  'Inland, Freightbarge with Containers',
  'Inland, Unit Carrier maritime',
  'Inland, Tug, Freighter/Tanker, coupled',
  'Inland, Tankbarge, Gas',
  'Inland, Tankbarge, dry cargo as if liquid',
  'Inland, Pushtow, six barges at least one tanker',
  'Naval Craft',
  'Minesweeper',
  'Accommodation Vessel',
  'Fish Storage Barge',
  'Inland Ferry',
  'Inland, Motor Tanker, Tug',
  'Naval Research Vessel',
  'Steam Supply Pontoon',
  'Supply Jack Up',
  'Crane Jack Up',
  'Maintenance Vessel',
  'Inland, Barge, Tanker, Chemical',
  'Offshore Safety Vessel',
  'Platform',
  'Air Cushion Ro-Ro/Passenger Ship',
  'Inland, Motor Freighter with Tanker',
  'Inland, Red Cross Ship',
  'Inland, Pushtow, seven cargo barges',
  'Air Cushion Patrol Vessel',
  'Inland, Hydrofoil',
  'Inland, Pushtow, four barges at least one tanker',
  'Inland, Pushtow, three barges at least one tanker',
  'Floating Dock',
  'Backhoe Dredger',
  'Naval Salvage Vessel',
  'Inland, Motor Freighter pushing Tank-ship(s)',
  'Grain Elevating Pontoon',
  'Kelp Dredger',
  'Inland, Catamaran Fast',
  'Pearl Shells Carrier',
  'Trenching Support Vessel',
  'Passenger Landing Craft',
  'Pumping Platform',
  'Pipe Layer Platform',
  'Air Cushion Passenger Ship',
  'Pontoon',
  'Repair Ship',
  'Desalination Pontoon',
  'Paddle Ship',
  'Pipe Burying Vessel',
  'Diving Support Platform',
  'Inland, Pushtow, seven barges at least one tanker',
  'Incinerator',
  'Car Park Pontoon',
  'Inland, Liquified Gas Tanker',
  'Sand Suction Dredger',
  'Torpedo Recovery Vessel',
  'Bucket Wheel Suction Dredger',
  'Inland, Pushtow, five barges at least one tanker',
] as const;

export const VesselSuperTypes = [
  'Cargo',
  'Fishing',
  'High Speed Craft',
  'Passenger',
  'Pleasure Craft',
  'Tanker',
  'Tugs And Special Craft',
  'Other',
] as const;

export type VesselSuperType = (typeof VesselSuperTypes)[number];
export type VesselSubType = (typeof kplerVesselTypes)[number];

/**
 * Normalises vessel subtype strings to handle formatting inconsistencies.
 */
const normaliseVesselSubType = (subType: string): string =>
  subType
    .trim()
    .toLowerCase()
    .replace(/\s*\/\s*/g, '/')
    .replace(/[\s_]+/g, ' ');

/**
 * Single source of truth mapping vessel supertypes to their corresponding subtypes.
 */
const VESSEL_MAPPING_SCHEMA: Record<VesselSuperType, string[]> = {
  Fishing: [
    'fishing',
    'fishing vessel',
    'trawler',
    'factory trawler',
    'fishery patrol vessel',
    'fishery research vessel',
    'fishery support vessel',
    'fish carrier',
    'fish factory',
    'fish storage barge',
    'inland, fishing boat',
    'kelp dredger',
    'whaler',
    'sealer',
    'pearl shells carrier',
  ],
  Tanker: [
    'tanker',
    'tanker crude',
    'tanker chemicals',
    'tanker product',
    'general tanker',
    'lng carrier',
    'gas carrier',
    'crude oil tanker',
    'oil products tanker',
    'oil/chemical tanker',
    'chemical tanker',
    'lpg tanker',
    'lng tanker',
    'bunkering tanker',
    'asphalt/bitumen tanker',
    'water tanker',
    'edible oil tanker',
    'fruit juice tanker',
    'co2 tanker',
    'wine tanker',
    'tank barge',
    'lpg/chemical tanker',
    'inland tanker',
    'tanker - hazard a (major)',
    'tanker - hazard b',
    'tanker - hazard c (minor)',
    'tanker - hazard d (recognizable)',
    'inland, motor tanker',
    'inland, motor tanker, liquid cargo, type c',
    'inland, motor tanker, liquid cargo, type n',
    'inland, motor tanker, dry cargo as if liquid',
    'inland, motor tanker, tug',
    'inland, tankbarge',
    'inland, tankbarge, liquid cargo, type c',
    'inland, tankbarge, liquid cargo, type n',
    'inland, tankbarge, gas',
    'inland, tankbarge, dry cargo as if liquid',
    'inland, gas tanker',
    'inland, liquified gas tanker',
    'inland, tanker',
    'inland, barge, tanker, chemical',
    'inland, tug, tanker',
    'inland, pushtow, one tank/gas barge',
    'inland, pushtow, two barges at least one tanker',
    'inland, pushtow, three barges at least one tanker',
    'inland, pushtow, four barges at least one tanker',
    'inland, pushtow, five barges at least one tanker',
    'inland, pushtow, six barges at least one tanker',
    'inland, pushtow, seven barges at least one tanker',
    'inland, pushtow, eight barges at least one tanker',
    'inland, pushtow, nine+ barges at least one tanker',
    'inland, motor freighter with tanker',
    'inland, motor freighter pushing tank-ship(s)',
  ],
  Cargo: [
    'cargo',
    'general cargo',
    'dry bulk',
    'container',
    'car carrier',
    'combination carrier',
    'livestock',
    'roll on roll off',
    'research vessel',
    'bulk carrier',
    'container ship',
    'ro-ro cargo',
    'reefer',
    'vehicles carrier',
    'deck cargo ship',
    'aggregates carrier',
    'cement carrier',
    'ore carrier',
    'wood chips carrier',
    'timber carrier',
    'limestone carrier',
    'pallet carrier',
    'self discharging bulk carrier',
    'barge carrier',
    'obo carrier',
    'bulk carrier with vehicle deck',
    'cargo barge',
    'ro-ro/container carrier',
    'rail/vehicles carrier',
    'cabu carrier',
    'stone carrier',
    'powder carrier',
    'aggregates barge',
    'cement barge',
    'pipe carrier',
    'livestock carrier',
    'cargo - hazard a (major)',
    'cargo - hazard b',
    'cargo - hazard c (minor)',
    'cargo - hazard d (recognizable)',
    'inland cargo',
    'inland ro-ro cargo ship',
    'inland, motor freighter',
    'inland, motor freighter pushing freighter(s)',
    'inland, motor freighter with ships alongside',
    'inland, motor freighter, tug',
    'inland, container vessel',
    'inland, freightbarge',
    'inland, freightbarge with containers',
    'inland, general cargo maritime',
    'inland, unit carrier maritime',
    'inland, bulk carrier maritime',
    'deck cargo pontoon',
    'nuclear fuel carrier',
  ],
  Passenger: [
    'passenger',
    'passenger ship',
    'vehicle passenger',
    'ro-ro/passenger ship',
    'passenger/cargo ship',
    'passenger landing craft',
    'inland passenger ship',
    'air cushion passenger ship',
    'inland, passenger ship, ferry, cruise ship',
    'inland, passenger ship without accommodation',
    'inland, cruise ship',
    'inland ferry',
    'inland, ferry',
  ],
  'High Speed Craft': [
    'high speed craft',
    'hydrofoil',
    'hovercraft',
    'inland, hydrofoil',
    'inland, catamaran fast',
    'inland, fast ship',
    'air cushion ro-ro/passenger ship',
    'air cushion patrol vessel',
    'wing in grnd',
    'wing in ground effect vessel',
  ],
  'Pleasure Craft': [
    'pleasure craft',
    'yacht',
    'sailing vessel',
    'sailing',
    'inland, pleasure craft, >20 metres',
  ],
  'Tugs And Special Craft': [
    'tugs and special craft',
    'tug',
    'pusher tug',
    'articulated pusher tug',
    'towing vessel',
    'tug/supply vessel',
    'tug/ice breaker',
    'inland tug',
    'inland, tug, single',
    'inland, tug, freighter',
    'inland, tug, one or more tows',
    'inland, tug, assisting a vessel or combination',
    'inland, tug freighter, coupled',
    'inland, tug, freighter/tanker, coupled',
    'inland, pushboat, single',
    'inland, pushtow, one cargo barge',
    'inland, pushtow, two cargo barges',
    'inland, pushtow, three cargo barges',
    'inland, pushtow, four cargo barges',
    'inland, pushtow, five cargo barges',
    'inland, pushtow, six cargo barges',
    'inland, pushtow, seven cargo barges',
    'inland, pushtow, eigth cargo barges',
    'inland, pushtow, eight cargo barges',
    'inland, pushtow, nine or more barges',
    'dredger',
    'hopper dredger',
    'trailing suction hopper dredger',
    'sand suction dredger',
    'suction dredger',
    'bucket ladder dredger',
    'cutter suction dredger',
    'backhoe dredger',
    'bucket wheel suction dredger',
    'motor hopper',
    'hopper barge',
    'grab dredger',
    'inland dredger',
    'inland, maintainance craft, cableship, dredger',
    'sar',
    'sar aircraft',
    'pilot vessel',
    'pilot ship',
    'patrol vessel',
    'law enforce',
    'law enforcement',
    'military ops',
    'offshore',
    'anti-pollution',
    'pollution control vessel',
    'medical trans',
    'dive vessel',
    'diving support vessel',
    'diving support platform',
    'port tender',
    'fire fighting vessel',
    'salvage/rescue vessel',
    'standby safety vessel',
    'research/survey vessel',
    'offshore supply ship',
    'multi purpose offshore vessel',
    'offshore construction vessel',
    'anchor handling vessel',
    'work vessel',
    'utility vessel',
    'special craft',
    'special vessel',
    'crew boat',
    'buoy-laying vessel',
    'cable layer',
    'pipe layer',
    'pipe layer platform',
    'heavy lift vessel',
    'crane ship',
    'crane barge',
    'floating crane',
    'pipelay crane vessel',
    'offshore construction jack up',
    'drilling jack up',
    'drill ship',
    'drill barge',
    'support jack up',
    'accommodation jack up',
    'crane jack up',
    'supply jack up',
    'well stimulation vessel',
    'production testing vessel',
    'floating storage/production',
    'icebreaker',
    'naval auxiliary vessel',
    'logistics naval vessel',
    'combat vessel',
    'naval craft',
    'minesweeper',
    'naval research vessel',
    'naval salvage vessel',
    'replenishment vessel',
    'torpedo recovery vessel',
    'troopship',
    'offshore safety vessel',
    'trenching support vessel',
    'pipe burying vessel',
    'pile driving vessel',
    'mooring vessel',
    'supply vessel',
    'supply tender',
    'inland supply vessel',
    'landing craft',
    'inland, service vessel, police patrol',
    'inland, red cross ship',
    'drilling rig',
    'search and rescue',
  ],
  Other: [],
};

// The following mappings are created once on application load.
// This allows us to use them for fast lookups in the mapVesselSubTypeToSuperType and mapVesselSuperTypeToSubType functions.

// Map of normalised strings to corresponding SuperTypes.
const SUBTYPE_TO_SUPERTYPE: Record<string, VesselSuperType> = {};
// Map of supertypes to corresponding raw kpler types.
const SUPERTYPE_TO_SUBTYPES = {} as Record<VesselSuperType, VesselSubType[]>;
VesselSuperTypes.forEach((type) => {
  SUPERTYPE_TO_SUBTYPES[type] = [];
});

kplerVesselTypes.forEach((rawSubType) => {
  const normalisedSubType = normaliseVesselSubType(rawSubType);
  const foundSuperType =
    VesselSuperTypes.find((type) =>
      VESSEL_MAPPING_SCHEMA[type].includes(normalisedSubType)
    ) || 'Other';
  SUBTYPE_TO_SUPERTYPE[normalisedSubType] = foundSuperType;
  SUPERTYPE_TO_SUBTYPES[foundSuperType].push(rawSubType);
});

/**
 * Returns the VesselSuperType associated with a given VesselSubType.
 */
export function mapVesselSubTypeToSuperType(
  subType: string | null | undefined
): VesselSuperType {
  if (!subType) return 'Other';
  return SUBTYPE_TO_SUPERTYPE[normaliseVesselSubType(subType)] || 'Other';
}

/**
 * Returns the array of raw VesselSubTypes associated with a given VesselSuperType.
 */
export function mapVesselSuperTypeToSubType(
  superType: VesselSuperType
): VesselSubType[] {
  return SUPERTYPE_TO_SUBTYPES[superType];
}

/**
 * Converts an array of vessel subtypes to unique supertypes.
 */
export function mapVesselSubTypesToUniqueSuperTypes(
  subTypes: string[]
): VesselSuperType[] {
  const superTypes = subTypes.map((shipType) =>
    mapVesselSubTypeToSuperType(shipType)
  );
  return Array.from(new Set(superTypes)) as VesselSuperType[];
}

export const VesselSuperTypeColours: Record<VesselSuperType, string> = {
  Cargo: '#2343fa',
  Fishing: '#42f542',
  'High Speed Craft': '#7f009c',
  Passenger: '#fbfc9a',
  'Pleasure Craft': '#fa5c23',
  Tanker: '#1d7334',
  'Tugs And Special Craft': '#f70f93',
  Other: '#FFFFFF',
};

export const NonVesselColours = {
  Buoy: '#ffc400',
  FishingNet: '#ffffff',
} as const;
